{
   "createPassword": {
      "success": {
         "status": "success",
         "messageEmoji": "🥳",
         "message": "Welcome to Juilliard Creative Classroom.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "‼️",
         "message": "An error occured.",
         "duration": 5000
      }
   },
   "forgotPassword": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "We have emailed your password reset link.",
         "duration": 5000
      },
      "error": {
         "status": "warning",
         "messageEmoji": "⚠️",
         "message": "Please wait before retrying.",
         "duration": 5000
      }
   },
   "resetPassword": {
      "success": {
         "status": "success",
         "messageEmoji": "🥳",
         "message": "Your password has been successfully reset.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "‼️",
         "message": "Current password does not match our records.",
         "duration": 5000
      }
   },
   "updatePassword": {
      "success": {
         "status": "success",
         "messageEmoji": "🥳",
         "message": "Password updated successfully.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "‼️",
         "message": "Current password does not match our records.",
         "duration": 5000
      }
   },
   "login": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "Success! Welcome Back.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "⚠️",
         "message": "Login failed. Please check your password and email and try again.",
         "duration": 5000
      }
   },
   "completeOnboarding": {
      "success": {
         "status": "success",
         "messageEmoji": "🎉",
         "message": "Success! You have completed the onboarding process.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "⚠️",
         "message": "An error occurred while completing the onboarding process.",
         "duration": 5000
      }
   },
   "completePdOnboarding": {
      "success": {
         "status": "success",
         "messageEmoji": "🎉",
         "message": "Success! You have completed the PD onboarding process.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "⚠️",
         "message": "An error occurred while completing the PD onboarding process.",
         "duration": 5000
      }
   },
   "updateProfile": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "Profile updated successfully.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "‼️",
         "message": "Unable to update profile.",
         "duration": 5000
      }
   },
   "uploadAvatar": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "Avatar updated successfully.",
         "duration": 5000
      },
      "serverError": {
         "status": "error",
         "messageEmoji": "‼️",
         "message": "Filesize too large. Please use a max size of 2mb",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "‼️",
         "message": "Please make sure your image is the correct file type - jpg or png, and a max size of 2mb",
         "duration": 5000
      }
   },

   "completeClassResource": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "You've completed \"%s\".",
         "duration": 5000
      }
   },
   "incompleteClassResource": {
      "success": {
         "status": "warning",
         "messageEmoji": "🔄",
         "message": "You've marked \"%s\" as incomplete.",
         "duration": 5000
      }
   },
   "addToProfile": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "\"%s\" has been added to your profile.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "⚠️",
         "message": "There was an error adding \"%s\" to your profile.",
         "duration": 5000
      }
   },
   "removeFromProfile": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "\"%s\" has been removed from your profile.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "⚠️",
         "message": "There was an error removing \"%s\" from your profile.",
         "duration": 5000
      }
   },
   "addToClass": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "\"%s\" has been added to this class.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "⚠️",
         "message": "There was an error adding \"%s\" to this class.",
         "duration": 5000
      }
   },
   "removeFromClass": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "\"%s\" has been removed from this class.",
         "duration": 5000
      },
      "error": {
         "status": "error",
         "messageEmoji": "⚠️",
         "message": "There was an error removing \"%s\" from this class.",
         "duration": 5000
      }
   },
   "saveNote": {
      "status": "success",
      "messageEmoji": "✍️",
      "message": "Note saved!",
      "duration": 5000
   },
   "addComment": {
      "status": "success",
      "messageEmoji": "💬",
      "message": "Comment added!",
      "duration": 5000
   },
   "addRating": {
      "status": "success",
      "messageEmoji": "🌟",
      "message": "Rating submitted!",
      "duration": 5000
   },
   "createClassNote": {
      "success": {
         "status": "success",
         "messageEmoji": "📝",
         "message": "Your note was created.",
         "duration": 5000
      }
   },
   "removeClassNote": {
      "success": {
         "status": "success",
         "messageEmoji": "🗑️",
         "message": "Your note was removed.",
         "duration": 5000
      }
   },
   "archiveClass": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "You've successfully archived this class.",
         "duration": 5000
      }
   },
   "updateClassSettings": {
      "success": {
         "status": "success",
         "messageEmoji": "✅",
         "message": "Successfully updated class settings.",
         "duration": 5000
      }
   }
}
